// React
import React, { Component } from "react";

// Components
import { MessageBox } from '../../Components';
import { Key, Instructions } from './';

// Stores
import { ClientRoutes } from '../../Routes';
import { UserProfileStore } from '../../Stores';

// Libraries
import Moment from 'moment';

// Styles
import './apiKeys.css';

class ApiKeys extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            exchange : 'Poloniex',
            apiKey : "",
            secret : "",
            keys : [],
            agreeToTerms : false,
            showSaveModal : false,
            showTermsModal : false,
            showDeleteModal : false,
            instructions : {
                Kraken : [
                    {
                        'step' : 'Login to Kraken',
                        'image' : 'somewhere'
                    },
                    {
                        'step' : 'Navigate to account panel',
                        'image' : 'somewhere'
                    },
                    {
                        'step' : 'Open keys',
                        'image' : 'somewhere'
                    },
                    {
                        'step' : 'click create',
                        'image' : 'somewhere'
                    },
                    {
                        'step' : 'copy it',
                        'image' : 'somewhere'
                    },
                    {
                        'step' : 'paste it',
                        'image' : 'somewhere'
                    }
                ],
                Poloniex : [
                    {
                        'step' : "Login to your Poloniex account and select 'API Keys' from the dropdown with the wrench icon.",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/poloniex_1.png',
                        'name' : 'Poloniex Step One'
                    },
                    {
                        'step' : "On the 'API Keys' page, you should see 'API ACCESS IS ENABLED' at the top.  If not, then you likely need to finish validating your Poloniex account. If you do, then great.  Click the 'Create New Key' button at the bottom of the page.",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/poloniex_2.png',
                        'name' : 'Poloniex Step Two'
                    },
                    {
                        'step' : 'Poloniex will now let you know that they have sent an email asking for your permission to create the key.  Follow the instructions in the email to be re-directed to the next step.',
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/poloniex_3.png',
                        'name' : 'Poloniex Step Three'
                    },
                    {
                        'step' : "After you confirm the email, return to the 'API Keys' page where you should see your new key.  Ensure that both 'Enable Trading' and 'Enable Withdrawals' are not checked.  Once you have double-checked that neither options are selected, proceed to the next step.",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/poloniex_4.png',
                        'name' : 'Poloniex Step Four'
                    },
                    {
                        'step' : "Beside the 'Secret' field of the API Key, select 'Show.'  Again, Poloniex will send you another email. Follow the instructions in the email to be re-directed to the final step. ",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/poloniex_5.png',
                        'name' : 'Poloniex Step Five'
                    },
                    {
                        'step' : 'You will now see your Secret in plain text.  Copy and paste both your API Key and Secret into the fields here in Yety.  After we securely store your keys, you can return to the Dashboard page to see your new account analytics!',
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/poloniex_6.png',
                        'name' : 'Poloniex Final Step'
                    },
                    {
                        'step' : 'If you have any had any issues with the previous steps, please contact us at accounts@yety.io',
                        'image' : '',
                        'name' : 'Yety Support'
                    }
                ],
                Coinbase : [
                    {
                        'step' : "Login to your Coinbase account and select 'Settings' in the top navigation bar.  Then select 'API Access' and further down to the right, select '+ New API Key.'",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/coinbase_1.png',
                        'name' : 'Coinbase Step One'
                    },
                    {
                        'step' : "Follow any 2-step verification prompts, if applicable.",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/coinbase_2.png',
                        'name' : 'Coinbase Step Two'
                    },
                    {
                        'step' : "After verifying your account, you will be shown a modal with many permissions. Select 'all' Accounts at the top and then copy the selections from the screen shot.  If you are unsure, do not select any permissions unless they say 'read.' Once you've completed this, scroll down and click 'Create.'",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/coinbase_3.png',
                        'name' : 'Coinbase Step Three'
                    },
                    {
                        'step' : "After selecting your permissions, you will be shown a final modal containing your 'API Key Details.' Copy and paste both your API Key and API Secret into the fields here in Yety.  After we securely store your keys, you can return to the Dashboard page to see your new account analytics!",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/coinbase_4.png',
                        'name' : 'Coinbase Final Step'
                    },
                    {
                        'step' : 'If you have any had any issues with the previous steps, please contact us at accounts@yety.io',
                        'image' : '',
                        'name' : 'Yety Support'
                    }
                ],
                BitTrex : [
                    {
                        'step' : "Login to your Bittrex account and select 'Settings' in the top navigation bar.  If prompted to turn on 2 factor auth, then proceed with that.  Otherwise, continue and select 'API Keys' on the left side of the page. Finally, click the 'Add new key...' option.",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/bittrex_1.png',
                        'name' : 'Bittrex Step One'
                    },
                    {
                        'step' : "You will now see the New Key listed.  Turn on only the 'READ INFO' toggle and do not turn on any others.  Click the 'Save' button at the bottom right of the page.",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/bittrex_2.png',
                        'name' : 'Bittrex Step Two'
                    },
                    {
                        'step' : "Verify your account with the Authenticator Code prompt and select 'Confirm.'",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/bittrex_3.png',
                        'name' : 'Bittrex Step Three'
                    },
                    {
                        'step' : "You will now see your new Key and Secret fields.  Copy and paste both your API Key and API Secret into the fields here in Yety.  After we securely store your keys, you can return to the Dashboard page to see your new account analytics!",
                        'image' : 'https://s3-us-west-2.amazonaws.com/yety-app/screenshots/bittrex_4.png',
                        'name' : 'Bittrex Final Step'
                    },
                    {
                        'step' : 'If you have any had any issues with the previous steps, please contact us at accounts@yety.io',
                        'image' : '',
                        'name' : 'Yety Support'
                    }
                ],
            },
            message : null
        };

        this.removeKey = this.removeKey.bind(this);
    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('ApiKeys.componentDidMount()');

        this.getAllKeys();

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Gets the current screen size
    getScreenSize() {
        return { width: window.innerWidth, height: window.innerHeight };
    }

    // Changes the exchange
    selectExchange = (newExchange) => {

        //console.log('ApiKeys.selectExchange(' + newExchange + ')');

        this.setState((prev, props) => {
            return {
                exchange : newExchange
            }
        });
        
    }

    // Changes the value of apikey on each keystroke
    updateApiKey = (event) => {
        
        var updatedApiKey = event.target.value;
            
        this.setState((prevState,props) => {
            return {
                apiKey: updatedApiKey
            }
        });
    }

    // Changes the value of secret on each keystroke
    updateSecret = (event) => {
        
        var updatedSecret = event.target.value;
            
        this.setState((prevState,props) => {
            return {
                secret: updatedSecret
            }
        });
    }

    // Saves the api key
    saveKey() {

        //console.log('ApiKeys.saveKey()');

        var key = {
            "exchange" : this.state.exchange,
            "apiKey" : this.state.apiKey.trim(),
            "secret" : this.state.secret.trim()
        };

        var user = UserProfileStore.getUser();

        ClientRoutes.saveApiKey(key, user.username)
            .then( (success) => {

                var msg = {
                    title : this.state.exchange + ' Key Saved',
                    details : 'Try refreshing the Overview or Holdings panels on the Dashboard page to see your updated analytics!',
                    type : 'success'
                };

                this.setState((prevState,props) => {
                    return {
                        apiKey : "",
                        secret : "",
                        showSaveModal: false,
                        message : msg
                    }
                });

                this.getAllKeys();

                return ClientRoutes.createPnlUser(user.username);

            })
            .then( (success) => {

                console.log('PnL User Profile Created: ' + success);

            })
            .catch( (error) => {

                var errorMessage = {
                    title : error.data,
                    details : error.message,
                    type : 'error'
                }

                this.setState((prevState,props) => {
                    return {
                        showSaveModal: false,
                        message : errorMessage
                    }
                });
                
            });
    }

    // Check key for issues
    sanitize(key) {


    }

    // Stages the key to be removed
    stageRemoveKey = (key) => {
        
        //console.log('ApiKeys.stageRemoveKey()');

        this.setState((prevState,props) => {
            return {
                removeKey: key,
                showDeleteModal: true
            }
        });
    }


    // Deletes staged key
    removeKey() {

        //console.log('ApiKeys.removeKey()');

        var user = UserProfileStore.getUser();

        ClientRoutes.deleteApiKey(user.username, this.state.removeKey)
            .then( (success) => {

                this.setState((prevState,props) => {
                    return {
                        showDeleteModal: false
                    }
                });

                this.getAllKeys();

            }).catch( (error) => {

                var errorMessage = {
                    title : error.data,
                    details: error.message,
                    type : 'error'
                }

                this.setState((prevState,props) => {
                    return {
                        showDeleteModal: false,
                        message : errorMessage
                    }
                });

            });

    }

    // Retrieves all keys for the current user
    getAllKeys() {

        //console.log('ApiKeys.getCurrentKeys()');

        var user = UserProfileStore.getUser();

        if(user !== null) {
        
            ClientRoutes.getApiKeys(user.username)
                .then( (apiKeys) => {

                    apiKeys.forEach(function(value, index) {
                        apiKeys[index].timestamp = Moment(apiKeys[index].timestamp);
                    });

                    this.setState((prevState,props) => {
                        return {
                            keys: apiKeys
                        }
                    });

                }).catch( (error) => {

                    var msg = {
                        title : error.data,
                        details: error.message,
                        type : 'error'
                    }

                    // Graceful catch for users that havent added any api keys
                    if(error.message.includes("No API Keys available for user")) {

                        msg = {
                            title : 'No Api Keys Available', 
                            details : 'Well at least you\'re in the right place to add them.',
                            type : 'warning'
                        }
                    }
    
                    this.setState((prevState,props) => {
                        return {
                            keys: [],
                            message : msg
                        }
                    });

                });

        }

    }

    // Agree to Terms and Conditions
    agreeToTermsAndConditions() {

        this.setState((prevState,props) => {
            return {
                agreeToTerms : !this.state.agreeToTerms
            }
        });

    }

/**********************************************************
 *  Modal Functions
 **********************************************************/

    // Given the modal name, show or hide modal
    toggleModal(modalName, show) {

        // Show Modal
        if(show) {

            if(modalName === "save") {
                this.setState((prevState,props) => {
                    return {
                        showSaveModal : true
                    }
                });
            }
            else if(modalName === "terms") {
                this.setState((prevState,props) => {
                    return {
                        showTermsModal : true
                    }
                });
            }
            else {
                this.setState((prevState,props) => {
                    return {
                        showDeleteModal : true
                    }
                });
            }

        }
        // Hide Modal
        else {
            if(modalName === "save") {
                this.setState((prevState,props) => {
                    return {
                        showSaveModal : false
                    }
                });
            }
            else if(modalName === "terms") {
                this.setState((prevState,props) => {
                    return {
                        showTermsModal : false
                    }
                });
            }
            else {
                this.setState((prevState,props) => {
                    return {
                        showDeleteModal : false
                    }
                });
            }
        }
        
    }

/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('ApiKeys.render()');

    return (

        <div className="page-container">

            {/*-----------  Remove Modal -----------*/}
            <div id="modal_remove" className={this.state.showDeleteModal ? "modal fade in show-modal" : "modal fade in hide-modal"}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.toggleModal.bind(this, 'delete', false)}>&times;</button>
                            <h2 className="modal-title">Remove Api Key</h2>
                        </div>

                        <div className="modal-body">
                            <h5 className="text-semibold">Please confirm that you would like to delete this api key.  Api Keys can be re-added at any time.</h5>    
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-link" onClick={this.toggleModal.bind(this, 'delete', false)}>Close</button>
                            <button type="button" className="btn btn-raised bg-danger-700 legitRipple" onClick={this.removeKey}>Delete Key</button>
                        </div>
                    </div>
                </div>
            </div>
            {/*-----------  / Remove Modal -----------*/}

            {/*-----------  Save Modal -----------*/}
            <div id="modal_save" className={this.state.showSaveModal ? "modal fade in show-modal" : "modal fade in hide-modal"}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.toggleModal.bind(this, "save", false)}>&times;</button>
                            <h2 className="modal-title">Save Api Key</h2>
                        </div>

                        <div className="modal-body">
                            <h5 className="text-semibold">Please confirm that you have read the instructions and would like to save this api key.</h5>    
                        </div>

                        <div className="modal-footer">
                            <div className="checkbox terms">
                                <label>
                                    <div className="checker border-primary-600 text-primary-800">
                                        <span className={this.state.agreeToTerms ? "checked" : ""}>
                                            <input type="checkbox" className="control-primary" onClick={this.agreeToTermsAndConditions.bind(this)}></input>
                                        </span>
                                    </div>
                                    I agree to the <span className="terms-link" onClick={this.toggleModal.bind(this, "terms", true)}>Terms and Conditions</span>
                                </label>
                            </div>
                            <button type="button" className="btn btn-link" onClick={this.toggleModal.bind(this, "save", false)}>Close</button>
                            <button type="button" onClick={this.saveKey.bind(this)}
                                className={this.state.agreeToTerms ? "btn btn-raised bg-success-700 legitRipple" : "btn btn-raised bg-success-700 disabled"}>
                                Save Key
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/*-----------  / Save Modal -----------*/}

            {/*-----------  Terms Modal -----------*/}
            <div id="modal_terms" className={this.state.showTermsModal ? "modal fade in show-modal" : "modal fade in hide-modal"}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.toggleModal.bind(this, "terms", false)}>&times;</button>
                            <h2 className="modal-title">Tems and Conditions</h2>
                        </div>

                        <div className="modal-body">
                            <h5 className="text-semibold">Term 1: The Yety Team Is Not Held Liable During Beta</h5>    
                            <p>If you follow the instructions as closely as possible, you have nothing to worry about.</p>
                            <h5 className="text-semibold">Term 2: Real terms and conditions coming soon</h5>    
                            <p>Coming after the beta.</p>
                        </div>

                        <div className="modal-footer">
                        
                            <button type="button" className="btn btn-raised bg-blue-300 legitRipple" onClick={this.toggleModal.bind(this, "terms", false)}>Ok, I Understand the Terms</button>
                        </div>
                    </div>
                </div>
            </div>
            {/*-----------  / Terms Modal -----------*/}

          <div className="page-content">

            <div className="content-wrapper">

              {/*-----------  Content Area -----------*/}
              <div className="content">

                {/*-----------  Top Row  -----------*/}
                <div className="row row-sortable ui-sortable">
                    
                    {/*-----------  Present Column -----------*/}
                    <div className="col-lg-7 col-md-7 col-sm-6 col-xs-12">

                        <Instructions exchange={this.state.exchange} instructions={this.state.instructions[this.state.exchange]} selectExchange={this.selectExchange} />
                        
                    </div>
                    {/*-----------  /Present Column -----------*/}

                    {/*-----------  Future Column -----------*/}
                    <div className="col-lg-5 col-md-5 col-sm-6 col-xs-12">
                    

                        {/*-----------  Margin/Positions Panel -----------*/}
                        <div className="panel panel-flat bg-theme-700">
                        
                            <div className="panel-heading">
                                <h5 className="panel-title">Add New Key</h5>
                                <div className="button-row">
                                    <div className="dropdown">
                                        <a type="button" className="btn btn-link dropdown-toggle legitRipple" 
                                            data-toggle="dropdown" aria-expanded="true">
                                            {this.state.exchange}
                                            <span className="caret"></span>
                                        </a>
                                        <ul className="dropdown-menu dropdown-menu-right">
                                            {/*<li onClick={() => this.selectExchange('Kraken')}><a href={null}>Kraken</a></li>*/}
                                            <li onClick={() => this.selectExchange('BitTrex')}><a href={null}>BitTrex</a></li>
                                            <li onClick={() => this.selectExchange('Coinbase')}><a href={null}>Coinbase</a></li>
                                            <li onClick={() => this.selectExchange('Poloniex')}><a href={null}>Poloniex</a></li>
                                        </ul>
                                    </div>
                                    
                                </div>
                            </div>

                            <div className="panel-body">

                                {/*-- row --*/}
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                        <div className="form-group has-feedback has-feedback-left">

                                            <input type="text" className="form-control" placeholder="api key"
                                            onChange={this.updateApiKey}
                                            value={this.state.apiKey}></input>
                                            <div className="form-control-feedback">
                                                <i className="icon-key text-size-large"></i>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                {/*-- / row --*/}

                                {/*-- row --*/}
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                        <div className="form-group has-feedback has-feedback-left">

                                            <input type="text" className="form-control" placeholder="secret"
                                            onChange={this.updateSecret}
                                            value={this.state.secret}></input>
                                            <div className="form-control-feedback">
                                                <i className="icon-lock2 text-size-large"></i>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                {/*-- / row --*/}
                                
                                {/*-- row --*/}
                                <div className="row error-row">
                                    <div className="col-lg-12 col-sm-12">
                                        <MessageBox message={this.state.message} type={'warning'}/>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                        <button type="button" className="btn btn-raised bg-blue-400 legitRipple pull-right"
                                            onClick={this.toggleModal.bind(this, 'save', true)}><span>Save Key</span></button>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        {/*-----------  /Margin/Positions Panel -----------*/}

                        {/*-----------  Margin/Positions Panel -----------*/}
                        <div className="panel panel-flat bg-theme-700">
                        
                            <div className="panel-heading">
                                <h5 className="panel-title">Your API Keys</h5>
                            </div>

                            <div className="panel-body">

                                <div className="row">
                                    {
                                        this.state.keys.map((key) => {
                                            
                                            return (
                                                <Key key={key._id} keyObj={key} removeKey={this.stageRemoveKey} />
                                            )
                                        })
                                    }
                                </div>

                            </div>
                        </div>
                        {/*-----------  /Margin/Positions Panel -----------*/}

                    </div>
                    {/*-----------  /Future Column -----------*/}

                </div>
                {/*-----------  /Grid -----------*/}

              </div>
              {/*-----------  /Content Area -----------*/}


            </div>

          </div>
        </div>
    );
  }
}

export default ApiKeys;





// WEBPACK FOOTER //
// ./src/Views/ApiKeys/ApiKeys.js